import { type MotionValue } from 'motion/react'
import {
  SplitViewHeader,
  SplitViewHeaderSearch,
} from '@/components/SplitView/SplitViewHeader'

export interface TeamListHeaderProps {
  searchText: string
  onSearchTextChange: (value: string) => void
  scrollOffset: MotionValue<number>
}

export function TeamListHeader({
  searchText,
  onSearchTextChange,
  scrollOffset,
}: TeamListHeaderProps) {
  return (
    <SplitViewHeader compact scrollOffset={scrollOffset}>
      <SplitViewHeaderSearch
        value={searchText}
        onChange={onSearchTextChange}
        placeholder="Search Teams"
      />
    </SplitViewHeader>
  )
}
